<template>
    <b-navbar toggleable="lg" type="dark" style="background-color: white" sticky>
    
    <div class="row carou">
      
        <b-carousel
      id="carousel-no-animation"
    style="text-shadow: 0px 0px 2px #000"
    no-animation
    controls
    indicators
    >

      <b-carousel-slide

        :img-src="$i18n.locale == 'es' ? 'http://www.nationalpanama.com/wp-content/uploads/2022/07/PROMOS_WEB_ENT_JUL-05.png' : 'http://www.nationalpanama.com/wp-content/uploads/2022/07/PROMOS_WEB_ENT_JUL-06.png'"
      ></b-carousel-slide>
      <b-carousel-slide
        style="background-color: #169A5A;"
        :img-src="$i18n.locale == 'es' ? 'http://www.nationalpanama.com/wp-content/uploads/2022/07/PROMOS_WEB_ENT_JUL-07.png' : 'http://www.nationalpanama.com/wp-content/uploads/2022/07/PROMOS_WEB_ENT_JUL-08.png'"
      ></b-carousel-slide>
      <!--<b-carousel-slide
        style="background-color: #169A5A;"        
        :img-src="$i18n.locale == 'es' ? 'http://panel.enterprisepanama.com/storage/ENT1_es.jpg' : 'http://panel.enterprisepanama.com/storage/ENT1_en.jpg'"
      ></b-carousel-slide>
      <b-carousel-slide
        style="background-color: #169A5A;"
        :img-src="$i18n.locale == 'es' ? 'http://panel.enterprisepanama.com/storage/ENT2_es.jpg' : 'http://panel.enterprisepanama.com/storage/ENT2_en.jpg'"
      ></b-carousel-slide>
      <b-carousel-slide
        style="background-color: #169A5A;"
        :img-src="$i18n.locale == 'es' ? 'http://panel.enterprisepanama.com/storage/ENT3_es.jpg' : 'http://panel.enterprisepanama.com/storage/ENT3_en.jpg'"
      ></b-carousel-slide>-->
  

    </b-carousel>
      
    </div>
      
  </b-navbar>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
 /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .carou{
  margin-left: 2%;
  margin-right: 2%;
}
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .carou{
  margin-left: 2%;
  margin-right: 2%;
}
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .carou{
  margin-left: 2%;
  margin-right: 2%;
}
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .carou{
  margin-left: 10%;
  margin-right: 10%;
}
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
.carou{
  margin-left: 20%;
  margin-right: 20%;
}
} 
</style>